import React from "react";
import { useI18n } from "../i18n";

const Cookies = () => {
  const { t } = useI18n();
  const p = t("cookies");
  return (
    <section data-testid="cookies-page" className="bg-[#0B1120]">
      <div className="max-w-4xl mx-auto px-5 sm:px-8 py-16 lg:py-20">
        <span className="text-xs font-mono uppercase tracking-widest text-emerald-400">
          {p.updated}
        </span>
        <h1 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">
          {p.title}
        </h1>
        <p className="mt-6 text-slate-300 leading-relaxed">{p.intro}</p>
        <div className="mt-10 space-y-8">
          {p.sections.map((s, i) => (
            <div key={i}>
              <h2 className="text-xl font-semibold text-white">{s.title}</h2>
              <p className="mt-2 text-slate-400 leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Cookies;
